import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import UIkit from './plugin/uikit/index.js'
import i18n from './i18n'

import LxzlTrack from 'lxzl-track-vue3';

import '@/assets/css/layout.less'


var app = createApp(App)

app.use(store)
   .use(router)
   .use(UIkit)
   .use(LxzlTrack, app, {router, platformId: '3aeeac6dc948042c2277050cc9550976', apiUrl: process.env.VUE_APP_RENT_STATIC_URL})
   .use(i18n)
   .mount('#app')
